export function newRisk(overrides = {}) {
  return {
    stepTitle: "",
    title: "",
    action: "",
    measurement: "",
    legal: "",
    relevantForPregnant: false,
    actionForPregnant: "",
    responsible: "",
    riskClassification: 1,
    riskClassificationAfterAction: 0,
    involvesThirdParties: false,
    requiresSpecialTraining: false,
    hazardFactor: null,
    hazardFactors: [],
    hazardPoints: [],
    hazardDescription: "",
    measureType: "",
    measureTypeText: "",
    stopMeasures: {
      S: { text: "", action: "", measurement: "" },
      T: { text: "", action: "", measurement: "" },
      O: { text: "", action: "", measurement: "" },
      P: { text: "", action: "", measurement: "" },
    },
    furtherMeasures: false,
    furtherMeasuresText: "",
    riskClassificationAfterFurtherMeasures: null,
    responsibleUser: null,
    implementBy: null,
    effectiveFrom: null,
    ticket: null,
    dialogs: {
      classificationDialog: { open: false },
      afterActionDialog: { open: false },
    },
    ...overrides,
  };
}
